// @ts-check
import {
  Box,
  DownloadIcon,
  ListsIcon,
  Menu,
  MenuButton,
  MenuLink,
  MenuList,
  MessageIcon,
  TableCell,
  TableRow,
  Text,
} from '~/design-system';
import { Trans } from '@lingui/macro';
import Moment from 'moment';
import { useCommonLinks } from '../../../pages/imports/_config';
import ImportTypeLabel from '../ImportTypeLabel';
import useProductListUrl from '~/components/useProductListUrl';
import { gql } from '@apollo/client';

export default function CompletedImportRow({ oneImport }) {
  const link = useCommonLinks();
  const productListUrl = useProductListUrl({
    productListId: oneImport.productListId,
  });
  return (
    <TableRow>
      <TableCell
        sx={{
          height: '65px',
          textAlign: 'left',
        }}
      >
        <Text>{oneImport.name}</Text>
        <ImportTypeLabel type={oneImport.type} />
      </TableCell>
      <TableCell sx={{ height: '65px', textAlign: 'left' }}>
        <Text variant="small">{oneImport.creator?.fullName}</Text>
        <Text variant="smallest">{oneImport.creator?.email}</Text>
      </TableCell>
      <TableCell sx={{ height: '65px', textAlign: 'left' }}>
        <Text>{Moment(oneImport.createdAt).format('LL')}</Text>
        <Text variant="smallest">
          {Moment(oneImport.createdAt).format('LT')}
        </Text>
      </TableCell>
      <TableCell sx={{ height: '65px', textAlign: 'left' }}>
        <Menu>
          <MenuButton variant="icon">
            <Box
              sx={{
                border: '1px solid #ccc',
                borderRadius: 3,
                paddingY: 0,
                paddingX: 2,
              }}
            >
              ···
            </Box>
          </MenuButton>
          <MenuList
            sx={{
              zIndex: 2,
              position: 'relative',
            }}
          >
            {oneImport.type === 'productMasterListImport' && (
              <MenuLink
                title="Send notification"
                href={link.sendNotification({
                  importType: oneImport.type,
                  importId: oneImport.importId,
                })}
              >
                <MessageIcon sx={{ marginRight: 2, marginTop: -1 }} />
                <Trans>Send notification</Trans>
              </MenuLink>
            )}
            <MenuLink href={oneImport.source.url}>
              <DownloadIcon sx={{ marginRight: 2, marginTop: -1 }} />
              <Trans>Download source file</Trans>
            </MenuLink>
            {oneImport.outputUrl && (
              <MenuLink target="_blank" href={oneImport.outputUrl}>
                <DownloadIcon sx={{ marginRight: 2, marginTop: -1 }} />
                <Trans>Download report</Trans>
              </MenuLink>
            )}
            {productListUrl && (
              <MenuLink target="_blank" href={productListUrl}>
                <ListsIcon sx={{ marginRight: 2, marginTop: -1 }} />
                <Trans>Open products list</Trans>
              </MenuLink>
            )}
          </MenuList>
        </Menu>
      </TableCell>
    </TableRow>
  );
}

CompletedImportRow.fragment = gql`
  fragment CompletedImportRow on DataImport {
    productListId
  }
`;
